import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ru from 'vuetify/lib/locale/ru';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      defaultTheme: 'light',
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: '#0097FD',
        secondary: '#424242',
        accent: '#E30611',
        error: '#C90000',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
    lang: {
      locales: { ru },
      current: 'ru',
    },
  icons: {
    iconfont: 'fa4',
  },
});
